module.exports = __webpack_public_path__ + "static/media/torcuato.18b815b2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/clubs/torcuato.jpg
// module id = 91
// module chunks = 0